import { ReviewSectionStore } from './../review-section.store';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ReviewSectionService } from '../review-section.service';
import { SectionIdentifier, SectionMessage } from '../review-section.domain';
import { ErrorService } from 'src/app/services/error/error.service';
import { DestroyableComponent } from 'src/app/common/destroyable.component';

@Component({
  selector: 'app-review-message-input',
  templateUrl: './review-message-input.component.html',
  styleUrls: ['./review-message-input.component.scss'],
})
export class ReviewMessageInputComponent extends DestroyableComponent implements OnInit {
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private reviewSectionService: ReviewSectionService,
    private reviewSectionStore: ReviewSectionStore,
    private errorService: ErrorService
  ) {
    super();
  }

  @Input() applicationId: number;
  @Input() sectionId: SectionIdentifier;
  @Output() messageAdded = new EventEmitter<SectionMessage>();

  ngOnInit(): void {
    this.form = this.fb.group({
      message: new FormControl('', [Validators.required, Validators.maxLength(250)]),
    });
  }

  sendMessage() {
    this.preventLeak(
      this.reviewSectionService.createSectionMessage({
        application_id: this.applicationId,
        content: this.form.value.message,
        section: this.sectionId,
      })
    ).subscribe(
      (message: SectionMessage) => {
        this.reviewSectionStore.addSectionMessage(message);
        this.form.patchValue({ message: '' });
        this.messageAdded.emit(message);
      },
      error => this.errorService.throwErrorIfFailure(error, true)
    );
  }
}
